import type { CardFoilId } from '../types/foil'
import type { PackId } from '../packs/ids'

/** First UTC instant the list accepts Quick Matches. 2026-09-24. */
export const LAST_CALL_START_MS = Date.UTC(2026, 8, 24)

/** Inclusive days. The list freezes at this instant. */
export const LAST_CALL_DAYS = 14

export const LAST_CALL_END_MS =
  LAST_CALL_START_MS + LAST_CALL_DAYS * 24 * 60 * 60 * 1000

export const LAST_CALL_FRAME_AT = 3
export const LAST_CALL_PORTRAIT_AT = 5
export const LAST_CALL_SLEEVE_AT = 8
export const LAST_CALL_MAT_AT = 14
export const LAST_CALL_PACK_AT = 20

export const LAST_CALL_FRAME_ID = 'last-call'
export const LAST_CALL_PORTRAIT_ID = 'last-call-portrait'
export const LAST_CALL_SLEEVE_ID = 'last-call'
export const LAST_CALL_MAT_ID = 'last-call'

export const PROMO_PACK_ID: PackId = 'promo-lob'

/** Blue-Eyes White Dragon. */
export const PROMO_CARD_ID = '89631139'

/** Every foil above Super Rare. */
export const PROMO_FOILS = [
  'ultra',
  'ghost',
  'helios',
  'nightglass',
  'stormwake',
] as const satisfies readonly CardFoilId[]

export type LastCallSnapshot = {
  played: number
  packGranted: boolean
  open: boolean
  endsAt: number
  /** Set when this update put the promo pack in the inventory. */
  packs?: Record<PackId, number>
}

export function lastCallOpen(now = Date.now()): boolean {
  return now >= LAST_CALL_START_MS && now < LAST_CALL_END_MS
}

export function lastCallSnapshot(
  played: number,
  packGranted: boolean,
  now = Date.now(),
): LastCallSnapshot {
  const n = Number.isInteger(played) && played > 0 ? played : 0
  return {
    played: n,
    packGranted: packGranted === true,
    open: lastCallOpen(now),
    endsAt: LAST_CALL_END_MS,
  }
}

export function lastCallFrameUnlocked(played: number): boolean {
  return played >= LAST_CALL_FRAME_AT
}

export function lastCallPortraitUnlocked(played: number): boolean {
  return played >= LAST_CALL_PORTRAIT_AT
}

export function lastCallSleeveUnlocked(played: number): boolean {
  return played >= LAST_CALL_SLEEVE_AT
}

export function lastCallMatUnlocked(played: number): boolean {
  return played >= LAST_CALL_MAT_AT
}
